import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SiteProofLogo from '../../../components/SiteProofLogo';

const PrivacyPageHeader = ({ title, lastUpdated }) => {
  return (
    <header className="bg-slate-900 border-b border-slate-800">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center gap-3 mb-6">
          <Link to="/" className="no-underline">
            <SiteProofLogo size="sm" />
          </Link>
        </div>
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors mb-4"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to SiteProof
        </Link>
        <h1 className="text-2xl sm:text-3xl font-bold text-white mt-2">{title}</h1>
        {lastUpdated && (
          <p className="text-sm text-slate-400 mt-2">Effective date: {lastUpdated}</p>
        )}
      </div>
    </header>
  );
};

export default PrivacyPageHeader;
